const CornerBrackets = ({ isOk, size = 32, thickness = 3, radius = 8 }) => {
  const color = isOk ? "#60a5fa" : "white";
  const corners = [
    { top: 0, left: 0, borderTop: thickness, borderLeft: thickness, borderRadius: `${radius}px 0 0 0` },
    { top: 0, right: 0, borderTop: thickness, borderRight: thickness, borderRadius: `0 ${radius}px 0 0` },
    { bottom: 0, left: 0, borderBottom: thickness, borderLeft: thickness, borderRadius: `0 0 0 ${radius}px` },
    { bottom: 0, right: 0, borderBottom: thickness, borderRight: thickness, borderRadius: `0 0 ${radius}px 0` },
  ];
  return (
    <>
      {corners.map((style, i) => (
        <div
          key={i}
          className="absolute transition-colors duration-300"
          style={{
            ...style,
            width: size,
            height: size,
            borderStyle: "solid",
            borderColor: color,
            borderTopWidth: style.borderTop ?? 0,
            borderRightWidth: style.borderRight ?? 0,
            borderBottomWidth: style.borderBottom ?? 0,
            borderLeftWidth: style.borderLeft ?? 0,
          }}
        />
      ))}
    </>
  );
};

export default CornerBrackets;
